// @flow
import { Text, View } from 'reshaped';

import type { Prepaid } from '@gandi/billing';

import { useTranslator } from '@gandi/translate';

export function PrepaidInfo({
  prepaid,
}: {
  prepaid: Prepaid,
}): React.MixedElement {
  const { __, formatPrice } = useTranslator();
  const { amount, currency } = prepaid;
  return (
    <View direction="row" justify="space-between">
      <Text as="p" variant="body-3">
        {__('From your prepaid account')}
      </Text>

      <Text as="p" variant="body-3">
        {formatPrice(amount, currency)}
      </Text>
    </View>
  );
}
